import React, { Component } from 'react'
import Slider from  'react-slick';
import { SliderArrowNext, SliderArrowPrev } from '../SliderGeneral/SliderArrows'
import getBrowserWidth from '../functions/getBrowserWidth'
// import StripeItem from './StripeItem.jsx';
import StripeItemLazy from './StripeItemLazy.jsx';


class Stripe extends Component {
    constructor(props) {
        super(props)

        this.state = {
            itemsToDisplay: 2,
            isChanging: false
        }

        this.props.settings.nextArrow = <SliderArrowNext />
        this.props.settings.prevArrow = <SliderArrowPrev />

        this.updateDimensions = this.updateDimensions.bind(this)
        this.onBeforeChange = this.onBeforeChange.bind(this)
        this.onAfterChange = this.onAfterChange.bind(this)
    }


    componentDidMount() {
        this.updateDimensions()
        window.addEventListener("resize",  _.debounce(this.updateDimensions, 300))
        window.addEventListener('touchstart', this.touchStart);
        window.addEventListener('touchmove', this.preventTouch, {passive: false});
    }


    componentWillUnmount() {
        window.removeEventListener("resize",  _.debounce(this.updateDimensions, 300))
        window.removeEventListener('touchstart', this.touchStart);
        window.removeEventListener('touchmove', this.preventTouch, {passive: false});
    }

    touchStart(e){
        this.firstClientX = e.touches[0].clientX;
        this.firstClientY = e.touches[0].clientY;
    }
    
    preventTouch(e) {
        const minValue = 15; // threshold
    
        this.clientX = e.touches[0].clientX - this.firstClientX;
        this.clientY = e.touches[0].clientY - this.firstClientY;
    
        // Vertical scrolling does not work when you start swiping horizontally.
        if(Math.abs(this.clientX) > minValue){ 

            e.preventDefault();
            e.returnValue = false;
            return false;
        }
    }
    
    getMovieItemLength(width) {
        if (this.props.theme === 'Arthouse') {
            if(width > 1449) {
                return 5
            }
            if(width > 759) {
                return 3
            }
            if(width > 519) {
                return 2
            }
            else {
                return 1
            }
        } else {
            if(width > 2150) {
                return 9
            }
            if(width > 1449) {
                return 7
            }
            if(width > 999) {
                return 5
            }
            if(width > 759) {
                return 3
            }
            if(width > 519) {
                return 2
            }
            else {
                return 1
            }
        }
    }


    updateDimensions() {
        const itemsToDisplay = this.getMovieItemLength(getBrowserWidth())

        if(itemsToDisplay !== this.state.itemsToDisplay) {
            this.setState({
                itemsToDisplay: itemsToDisplay
            })
        }
    }

    getSliderSettings() {
        const { settings, theme } = this.props
        if (theme === 'Arthouse') {
            return {
                ...settings,
                slidesToShow: 5,
                slidesToScroll: 3,
                responsive: [
                    { 
                        breakpoint: 519,
                        settings: { 
                            slidesToShow: 1,
                            slidesToScroll: 1,
                            swipeToSlide: true
                        } 
                    }, { 
                        breakpoint: 760,
                        settings: { 
                            slidesToShow: 2,
                            slidesToScroll: 1,
                            swipeToSlide: true
                        } 
                    }, { 
                        breakpoint: 1449, 
                        settings: { 
                            slidesToShow: 3,
                            slidesToScroll: 2,
                            swipeToSlide: true
                        } 
                    }
                ]
            }
        }
        else {
            return settings
        }
    }

    onBeforeChange(oldIndex, newIndex)  {
        this.setState({
            isChanging: true
        })
    }

    onAfterChange()  {
        this.setState({
            isChanging: false
        })
    }

    render() {
        const { itemsToDisplay, isChanging } = this.state
        const { 
            items, 
            moviesData, 
            adsData, 
            theme, 
            filterType, 
            filterValue,  
            translation, 
            scrollToPosition, 
            isMobile, 
            onClickSlideItem, 
            onOpenPerformancePage, 
            stripeAppearance //is needed for overwrite
        } = this.props
        const settings = this.getSliderSettings()

        if(items.length <= itemsToDisplay || stripeAppearance === 'no_slide') {
            return (
                <div className={"slider-inner-wrapper slider-stripes-wrapper has-no-slider"}>
                    {items.map((item, index) => {
                        return <StripeItemLazy
                            isChanging={isChanging}
                            item={item} 
                            moviesData={moviesData} 
                            adsData={adsData} 
                            key={index}
                            theme={theme} 
                            filterType={filterType} 
                            filterValue={filterValue}  
                            translation={translation} 
                            scrollToPosition={scrollToPosition} 
                            isMobile={isMobile} 
                            onClickSlideItem={onClickSlideItem} 
                            onOpenPerformancePage={onOpenPerformancePage} 
                            stripeAppearance={stripeAppearance}
                            />
                        })}
                </div>
            )
        } else {
            
            return (
                <div className={"slider-inner-wrapper slider-stripes-wrapper"}>
                    <Slider {...settings} beforeChange={this.onBeforeChange} afterChange={this.onAfterChange}>
                        {items.map((item, index) => {
                            return <StripeItemLazy
                                isChanging={isChanging}
                                item={item} 
                                moviesData={moviesData} 
                                adsData={adsData} 
                                key={index}
                                theme={theme} 
                                filterType={filterType} 
                                filterValue={filterValue}  
                                translation={translation} 
                                scrollToPosition={scrollToPosition} 
                                isMobile={isMobile} 
                                onClickSlideItem={onClickSlideItem} 
                                onOpenPerformancePage={onOpenPerformancePage} 
                                stripeAppearance={stripeAppearance}
                            />
                        })}
                    </Slider>
                </div>
            )
        }
    }
}

export default Stripe
